export default "__VITE_ASSET__BYRnYvg$__"